import React from 'react';

import { useResult } from '~/hooks/useResult';

import DateRow, { getDateRow } from '../../../Result/DateRow';
import ResultRow from '../../../Result/ResultRow';
import LiveReportList from './LiveReportList';
import { ReportProps } from './types';

export default function LiveResults({ strategyId, from, to, setFrom, setTo }: ReportProps) {
    const { results, totalFormatted, totalDirection, loading, onEndReached } = useResult(from, to, strategyId);

    return (
        <LiveReportList
            data={results}
            loading={loading}
            onEndReached={onEndReached}
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={setTo}
            totalFormatted={totalFormatted}
            totalDirection={totalDirection}
            renderDate={(item, index) =>
                getDateRow(item.timestamp, index) !== '' ? <DateRow timestamp={item.timestamp} /> : null
            }
            renderRow={(item, isOpen) => <ResultRow result={item} isOpen={isOpen} inStrategyView />}
        />
    );
}
